function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#4E9CD3",
  fillOpacity: 0.65,
  fillRule: "nonzero",
  d: "M11.999 4.001l.333.001c3.788.08 7.949 2.474 11.048 5.881a2.414 2.414 0 0 1-.002 3.233c-3.184 3.504-7.483 5.948-11.367 5.883h-.336c-3.818-.075-7.963-2.48-11.055-5.886a2.414 2.414 0 0 1 .002-3.232c3.184-3.504 7.5-5.94 11.377-5.88zm.012 1.5l-.334.001c-3.309.078-7.11 2.267-9.943 5.385a.912.912 0 0 0-.002 1.22c2.919 3.215 6.847 5.45 10.28 5.392l.31-.001c3.333-.078 7.113-2.273 9.944-5.388a.912.912 0 0 0 .002-1.22C19.34 7.67 15.39 5.444 12.011 5.501zM11.998 7a4.5 4.5 0 0 1 4.494 4.264l.007.238-.005.212a4.5 4.5 0 1 1-4.496-4.714zm0 1.5a3 3 0 1 0 3 3.001l-.006-.198A3 3 0 0 0 12 8.499z"
});

var SvgPasswordShow = function SvgPasswordShow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPasswordShow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/password-show.4c73e3b0.svg";
export { ForwardRef as ReactComponent };